import { useDebounce } from "usehooks-ts";
import { useNavigate, useOutletContext } from "react-router";
import { useQueryState } from "nuqs";
import { useState, useEffect } from "react";
import {
	Avatar,
	ChatContainer,
	ConversationHeader,
	Message,
	MessageList,
} from "@chatscope/chat-ui-kit-react";

import { AvatarWithPlaceholder } from "./AvatarWithPlaceholder";
import { MessageBubble } from "./MessageBubble";
import { MessageMenuInSearch } from "./MessageMenuInSearch";
import { Virtuoso } from "react-virtuoso";
import { useEffectEvent } from "../util";

import * as borogove from "borogove";

export const SearchMessages = () => {
	const navigate = useNavigate();
	const { active, persistence, client } = useOutletContext<{
		active: boolean;
		persistence: borogove.Persistence;
		client: borogove.Client;
	}>();
	const [searchQ] = useQueryState("q");

	const [searchMessageResults, setSearchMessageResults] = useState<
		borogove.ChatMessage[]
	>([]);
	const debouncedSearch = useDebounce(searchQ, 300);
	const doSearch = useEffectEvent(() => {
		const search = searchQ;
		if (search) {
			let results: borogove.ChatMessage[] = [];
			// TODO: what about sqlite persistence?
			(
				persistence as Awaited<ReturnType<typeof borogove.persistence.IDB>>
			).searchMessages(
				client.accountId(),
				null,
				search,
				(q: string, message: borogove.ChatMessage | null) => {
					if (q !== search || !message) return false;
					results = [message, ...results].sort(
						(x, y) =>
							new Date(x.timestamp).getTime() - new Date(y.timestamp).getTime(),
					);
					setSearchMessageResults(results);
					return true; // Continue searching
				},
			);
		}
	});
	useEffect(() => {
		doSearch();
	}, [debouncedSearch]);

	return (
		<ChatContainer className={active ? "active" : undefined}>
			<ConversationHeader>
				<ConversationHeader.Back onClick={() => navigate("../")} />
				<ConversationHeader.Content userName="Search Results" />
			</ConversationHeader>
			<div as={MessageList} className="cs-message-list">
				<Virtuoso
					key={searchQ}
					followOutput={true}
					alignToBottom={true}
					data={searchMessageResults}
					itemContent={(index, m) => {
						const chat = client.getChat(m.chatId());
						if (!chat) return <div />;

						const user = chat?.getParticipantDetails(m.senderId);
						return (
							<MessageBubble
								key={m.serverId || m.localId}
								chat={chat}
								position={"single"}
								accountId={client.accountId()}
								sender={user}
								parentSender={
									m.replyToMessage &&
									chat.getParticipantDetails(m.replyToMessage.senderId)
								}
								setSelectedThread={() => {}}
								m={m}
							>
								<AvatarWithPlaceholder
									as={Avatar}
									photoUri={user?.photoUri}
									placeholderUri={user?.placeholderUri}
									displayName={user?.displayName}
								/>

								<MessageMenuInSearch as={Message.Header} m={m} />
							</MessageBubble>
						);
					}}
				/>
			</div>
		</ChatContainer>
	);
};
